import React from 'react'
import { ReactEditor, useSelected, useSlate } from 'slate-react'
import { Registry } from '@react-registry'
//@ts-ignore
import styles from '../style.module.css'
import { cx } from '@emotion/css'
import useIsCellSelected from '../hooks/useIsCellSelected'
import { Editor, Range } from 'slate'
export * from './deserializer'

const TH = (props) => {
  const { attributes, children } = props
  const editor = useSlate()
  const path = ReactEditor.findPath(editor as ReactEditor, props.element)
  const [row, col] = path.slice(-2)
  const table = Editor.above(editor, { at: path, match: (node) => node["type"] === 'table' })
  let isSelectionOnlyInTable = false

  const tableRange = Editor.range(editor, table?.[1])

  if (editor.selection && tableRange.anchor && tableRange.focus) {
    isSelectionOnlyInTable =
      Range.includes(tableRange, Range.start(editor.selection)) &&
      Range.includes(tableRange, Range.end(editor.selection))
  }

  const isInRectangle = useIsCellSelected(path, table, "th")
  const defaultSelection = useSelected()
  const selected = isSelectionOnlyInTable ? isInRectangle : defaultSelection
  let { colSpan, rowSpan } = props?.element?.attrs ?? {}

  let spans = {}
  if (colSpan) {
    spans = { ...spans, colSpan }
  }
  if (rowSpan) {
    spans = { ...spans, rowSpan }
  }

  const rowColSpanStyles = (rowspan = 1, colspan = 1) => {
    const styles = {}
    styles['gridRow'] = `${row + 1} / span ${rowspan}`
    styles['gridColumn'] = `${col + 1} / span ${colspan}`
    return styles
  }
  if (editor.isVoid(props.element)) {
    return (
      <div tabIndex={-1} contentEditable="false" style={{ userSelect: 'none', position: 'absolute' }}>
        {props.children}
      </div>
    )
  }
  return (
    <div
      data-testid="th"
      className={cx(styles['div-table-cell-heading'], { [styles['div-table-cell-focus']]: selected })}
      data-type="table-cell-heading"
      style={rowColSpanStyles(rowSpan, colSpan)}>
      <div {...attributes} style={{ overflow: 'hidden', flexWrap: 'wrap', width: '100%' }}>
        {children}
      </div>
    </div>
  )
}

export default TH

Registry.register(
  {
    Component: TH,
    isContentStackElement: true,
    dndOptions: {
      DisableDND: true,
      DisableSelectionHalo: true,
    },
    toolbar: {
      inHoveringToolbar: false
    },
  },
  { id: 'th', registry: 'v2.element' }
)
